interface CustomChipPriorityProps {
    color?: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "yellow"
    label: string
    labelKey?: string
}

export interface ChipPriorityProps {
    type: PriorityEnum
    custom?: CustomChipPriorityProps
}

export enum PriorityEnum {
    None = 0,
    Low = 1,
    Medium = 2,
    High = 3,
    DrivingBan = 4
}

